import { styled } from 'styled-components';
import { useRef, useEffect } from 'react';

import { _useDispatch, _useSelector } from '@src/state/hooks';
import { useForm } from 'react-hook-form';
import Input from '@src/components/styled/Input';
import SmallButton from '@src/components/styled/SmallButton';
import Form from '@src/components/styled/Form';
import Select from '@src/components/styled/Select';
import Range from '@src/components/styled/Range';

import { useAccount } from 'wagmi';
import _createGame from '@src/io/events_out/_createGame';
import useWagerApprove from '@src/hooks/useWagerApprove';
import useWagerAllowance from '@src/hooks/useWagerAllowance';
import { pushEventQueue } from '@src/state/slices/slice_game';
import useWagerContractMeta from '@src/hooks/useWagerContractMeta';

const Container = styled.div`
  position: relative;
  display: flex;
  // flex-grow: 1;
  flex-direction: column;

  margin-top: 10pt;
  border: 2pt solid gray;
  padding-top: 10pt;
  padding-bottom: 10pt;

  width: 100%;
  min-width: 0;
  // overflow-y: scroll;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;
  text-align: center;
  

  ${Input} {
    max-width: 14rem;

    @media only screen and (max-width: 720px) {
      font-size: 1rem;   
    }
  }
`;

const WagerSliderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const WagerInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  text-align: center;
  margin-top: 1rem;
  width: 20rem;
`;

export default function CreateGameForm() {
  const dispatch = _useDispatch();

  const { isConnected } = useAccount();

  const { register, handleSubmit, watch } = useForm();

  const { minimumDMT, maximumDMT } = useWagerContractMeta();

  const name = watch('gameName');
  let isPublicValue = watch('isPublic');
  if (isPublicValue === undefined) isPublicValue = '1';

  const isPublic = isPublicValue === '1' ? true : false;
  const password = watch('gamePassword');

  let wagerValue = watch('wager');
  if (wagerValue === undefined) wagerValue = 0.0;
  const wager = parseFloat(wagerValue);
  const approve = useWagerApprove();
  const { data: allowance } = useWagerAllowance();

  const onSubmit = () => {
    const submitName = name;
    const submitIsPublic = isPublic;
    const submitPassword = isPublic ? null : password;

    const isWagered = wager > 0;

    const submitWager = isWagered && wager ? parseFloat(`${wager}`) : null;

    // if not wagered, create immediately
    if (!isWagered) {
      _createGame(
        submitName,
        submitIsPublic,
        submitPassword,
        isWagered,
        submitWager,
      );
    } else {
      // if wagered, check allowance and make user approve if necessary
      if (!allowance || parseFloat(allowance.toString()) < wager) {
        dispatch(
          pushEventQueue({
            message:
              'Increase your $GOLD allowance to create a challenge game.',
            showToast: true,
            sound: 'yourTurn',
          }),
        );
        approve?.();
      } else {
        // otherwise create game
        _createGame(
          submitName,
          submitIsPublic,
          submitPassword,
          isWagered,
          submitWager,
        );
      }
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <label>
          Name:{' '}
          <Input
            type='text'
            {...register('gameName')}
            style={{ width: '12rem' }}
          />
        </label>

        <label>
          Public:{' '}
          <Select {...register('isPublic')} style={{ width: '12rem' }}>
            <option value={1}>yes</option>
            <option value={0}>no</option>
          </Select>
        </label>
        {!isPublic && (
          <label>
            <span>&nbsp;</span>Pass:{' '}
            <Input {...register('gamePassword')} style={{ width: '12rem' }} />
          </label>
        )}

        {!isConnected && (
          <div style={{ fontSize: '1.5rem', marginTop: '7.5pt' }}>
            {' '}
            Connect your wallet to create $GOLD challenges
          </div>
        )}

        {isConnected && minimumDMT && maximumDMT && (
          <WagerInputContainer>
            <label>
              <WagerSliderRow>
                <Range
                  style={{ width: '16rem' }}
                  type='range'
                  value={wager}
                  {...register('wager')}
                  min={0.0}
                  max={maximumDMT}
                  step={minimumDMT}
                />
              </WagerSliderRow>
              <output>{wager} $GOLD</output>
            </label>
          </WagerInputContainer>
        )}

        <br />
        <SmallButton type='submit'>CREATE GAME</SmallButton>
      </Form>
    </Container>
  );
}
